import type {Result, UseCase} from 'framework';
import type {FocusModePreference} from '../../domain/focus-mode-preference.value-object';
import type {FocusModePreferenceRepository} from '../ports/focus-mode-preference.repository';

export class GetFocusModePreference implements UseCase<[], FocusModePreference> {
  constructor(private readonly repository: FocusModePreferenceRepository) {}

  execute(): Promise<Result<FocusModePreference>> {
    return this.repository.get();
  }
}
